import { BROKER_TYPES } from "../../types/types"

export const cellIdFromURL = () => {
    return parseInt(window.location.pathname.split("/").filter((item) => item)[2])
}

export const stepIdFromURL = () => {
    return parseInt(window.location.pathname.split("/").filter((item) => item)[3])
}

export const stepIdFrom = (pathname) => {
    return parseInt(pathname.split("/").filter((item) => item)[3])
}

export const studyIdFrom = (pathname) => {
    return parseInt(pathname.split("/")[2])
}

export const brokerTypeFromString = (bt) => {
    switch (bt) {
        case "standard":
            return BROKER_TYPES.STANDARD
        case "NOET":
        case "none":
            return BROKER_TYPES.NO_EYETRACKING
        case "MB":
            return BROKER_TYPES.MOUSE
        case "MMB":
            return BROKER_TYPES.MOBILEMOUSE
        case "AUTOMATED_TESTING_BROKER":
            return BROKER_TYPES.AUTOMATED_TESTING_BROKER
        case "X2":
            return BROKER_TYPES.X2
        case "AUDIBLE":
            return BROKER_TYPES.AUDIBLE
        default:
            return BROKER_TYPES.STANDARD
    }
}

export const passOnSearchParams = (searchParams, ignoreList, addList) => {
    let strOut = ''
    
    if(!!searchParams){
        Array.from(searchParams.entries()).forEach(([key, value]) => {
            if(!ignoreList.includes(key)){
                if(strOut.includes('?')){
                    strOut += `&${key}=${value}`
                } else {
                    strOut += `?${key}=${value}`
                }
            }
        })
    }

    if(!!addList && addList.length > 0){
    addList.forEach(({key, value}) => {
        if(key && value){
            if(strOut.includes('?')){
                strOut += `&${key}=${value}`
            } else {
                strOut += `?${key}=${value}`
            }
        }
    })
    }


    return strOut
}